export const WARNING_CONTAINER_ICON_SIZE = 48;
